var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBugSolid = function SvgBugSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 8v.25H16a.75.75 0 0 1 .437.14l3.159-2.022a.75.75 0 0 1 .808 1.264l-3.19 2.041A6.75 6.75 0 0 1 17.75 12v.25H21a.75.75 0 0 1 0 1.5h-3.25V15a5.75 5.75 0 0 1-.239 1.64l2.873 1.716a.75.75 0 0 1-.769 1.288l-2.721-1.625A5.752 5.752 0 0 1 12 20.75a5.75 5.75 0 0 1-4.894-2.731l-2.722 1.625a.75.75 0 0 1-.768-1.288l2.873-1.716A5.748 5.748 0 0 1 6.25 15v-1.25H3a.75.75 0 0 1 0-1.5h3.25V12l.001-.041a6.75 6.75 0 0 1 .535-2.286l-3.19-2.041a.75.75 0 1 1 .808-1.264l3.16 2.022A.75.75 0 0 1 8 8.25h.25V8a3.75 3.75 0 0 1 7.5 0Zm-5.341-1.591A2.25 2.25 0 0 1 14.25 8v.25h-4.5V8c0-.597.237-1.169.659-1.591Zm.841 12.774a4.248 4.248 0 0 0 1.5 0V14a.75.75 0 0 0-1.5 0v5.183Z",
    fill: "currentColor"
  })));
};
export default SvgBugSolid;